import { ottHeaderConstants } from '../constants/ott-header-constants';
import { StandardHttpHeaderConstants } from '../constants/standard-http-header-constants';
let scenarioHeaders;
export function setScenarioHeaders(scenarios = []) {
    if (Array.isArray(scenarios)) {
        scenarioHeaders = scenarios.join(', ');
        return;
    }
    if (typeof scenarios === 'string') {
        scenarioHeaders = scenarios;
    }
}
export function resetScenarioHeaders() {
    scenarioHeaders = undefined;
}
/**
 * Check available headers on: https://wiki.at.sky/pages/viewpage.action?spaceKey=OT&title=OTT+Headers
 *
 * @param {Record<string, any> & { customHeaders?: Record<string, string | boolean> }}
 * @returns {Record<string, string>} headers
 */
export function buildOttHeaders({ abProfileID, provider, proposition, territory, platform, device, deviceId, language, country, postalCode, ovpPinOverride, userToken, contentType, acceptContentType, tokenType, skyIdToken, pas, pasAlternate, customHeaders, partnerId, identifiers, partnerAccountId, coppa, isPrefetch, broadcastRegions, activeTerritory, deviceLanguage, appStoreTerritory, requestId, debug, bouquetId, subBouquetId, clientVersion, journeyContext, }) {
    const headers = {
        ...customHeaders,
        ...(scenarioHeaders && { 'X-Scenario': scenarioHeaders }),
    };
    if (provider) {
        headers[ottHeaderConstants.PROVIDER] = provider;
    }
    if (territory) {
        headers[ottHeaderConstants.TERRITORY] = territory;
    }
    if (language) {
        headers[ottHeaderConstants.LANGUAGE] = language;
    }
    if (proposition) {
        headers[ottHeaderConstants.PROPOSITION] = proposition;
    }
    if (abProfileID) {
        headers[ottHeaderConstants.AB_PROFILE_ID] = abProfileID;
    }
    if (platform) {
        headers[ottHeaderConstants.PLATFORM] = platform;
    }
    if (device) {
        headers[ottHeaderConstants.DEVICE] = device;
    }
    if (deviceId) {
        headers[ottHeaderConstants.DEVICE_ID] = deviceId;
    }
    if (country) {
        headers[ottHeaderConstants.COUNTRY] = country;
    }
    if (postalCode) {
        headers[ottHeaderConstants.POSTAL_CODE] = postalCode;
    }
    if (ovpPinOverride) {
        headers[ottHeaderConstants.OVP_PIN_OVERRIDE] = ovpPinOverride;
    }
    if (contentType) {
        headers["Content-Type" /* StandardHttpHeaderConstants.CONTENT_TYPE */] = contentType;
    }
    if (userToken) {
        headers[ottHeaderConstants.USER_TOKEN] = userToken;
    }
    if (tokenType) {
        headers[ottHeaderConstants.TOKEN_TYPE] = tokenType;
    }
    if (skyIdToken) {
        headers[ottHeaderConstants.ID_TOKEN] = skyIdToken;
    }
    if (acceptContentType) {
        headers["Accept" /* StandardHttpHeaderConstants.ACCEPT */] = acceptContentType;
    }
    if (pas) {
        headers[ottHeaderConstants.PAS] = pas;
    }
    if (pasAlternate) {
        headers[ottHeaderConstants.PAS_ALTERNATE] = pasAlternate;
    }
    if (partnerId) {
        headers[ottHeaderConstants.PARTNER_ID] = partnerId;
    }
    if (identifiers) {
        headers[ottHeaderConstants.IDENTIFIERS] = identifiers;
    }
    if (partnerAccountId) {
        headers[ottHeaderConstants.PARTNER_ACCOUNT_ID] = partnerAccountId;
    }
    if (typeof coppa !== 'undefined') {
        headers[ottHeaderConstants.COPPA] = coppa;
    }
    if (journeyContext) {
        headers[ottHeaderConstants.JOURNEY_CONTEXT] = journeyContext;
    }
    if (isPrefetch === true) {
        headers[ottHeaderConstants.PRE_PLAYOUT] = true;
    }
    if (deviceLanguage) {
        headers[ottHeaderConstants.DEVICE_LANGUAGE] = deviceLanguage;
    }
    if (appStoreTerritory) {
        headers[ottHeaderConstants.APP_STORE_TERRITORY] = appStoreTerritory;
    }
    if (broadcastRegions) {
        headers[ottHeaderConstants.BROADCAST_REGIONS] = broadcastRegions;
    }
    if (activeTerritory) {
        headers[ottHeaderConstants.ACTIVE_TERRITORY] = activeTerritory;
    }
    if (requestId) {
        headers[ottHeaderConstants.REQUEST_ID] = requestId;
    }
    if (debug) {
        headers[ottHeaderConstants.DEBUG] = debug;
    }
    if (bouquetId || bouquetId === 0) {
        headers[ottHeaderConstants.BOUQUET_ID] = bouquetId;
    }
    if (subBouquetId || subBouquetId === 0) {
        headers[ottHeaderConstants.SUB_BOUQUET_ID] = subBouquetId;
    }
    if (clientVersion) {
        headers[ottHeaderConstants.CLIENT_VERSION] = clientVersion;
    }
    return headers;
}
export function findHeaderIgnoreCase(headers, headerKeyToFind) {
    const matchedKey = Object.keys(headers).find((headerKey) => headerKeyToFind.toLowerCase() === headerKey.toLowerCase());
    if (matchedKey) {
        return headers[matchedKey];
    }
}
export function updateUserTokenFromResponse(ovpTokenService, userToken) {
    return (response) => ovpTokenService.updateOVPTokenFromHeaders(response, userToken).then(() => response);
}
//# sourceMappingURL=ott-request-utils.js.map